import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import ProjectAssignmentsPendingAbsences from "./ProjectAssignmentsPendingAbsences/ProjectAssignmentsPendingApprovals";
import ProjectAssignmentsPendingExpenses from "./ProjectAssignmentsPendingExpenses/ProjectAssignmentsPendingExpenses";
import ProjectAssignmentsPendingExtraHours from "./ProjectAssignmentsPendingExtraHours/ProjectAssignmentsPendingExtraHours";
import useAuthorization from "../../../custom-hooks/useAuthorization/useAuthorization";
import useQuery from "../../../custom-hooks/useQuery/useQuery";
import { Panel } from "../../../reusable-components/MultipleTabs/interfaces";
import MultipleTabs from "../../../reusable-components/MultipleTabs/MultipleTabs";
import { AUTHORIZATIONS } from "../../../utils/constants/authorization-constants";

export enum PENDING_APPROVALS_ROUTES {
  ABSENCES = "absences",
  EXTRA_HOURS = "extra-hours",
  EXPENSE_REPORTS = "expense-reports",
}

const ProjectAssignmentsPendingApprovals = () => {
  const { t } = useTranslation();
  const tRP = "components.project_assignment_pending_approvals"; // tRP - translation root path
  const translationFields = `${tRP}.tables`;

  const query = useQuery();

  const hasAccessToApproveTimeAndLeaves = useAuthorization([AUTHORIZATIONS.EmployeesAccess.ApproveTimeAndLeaves]);

  const hasAccessToApproveExpenses = useAuthorization([AUTHORIZATIONS.EmployeesAccess.ApproveExpenses]);

  const checkPanelAccess = useCallback((showPanel: boolean, panel: Panel) => (showPanel ? [panel] : []), []);

  const panels: Panel[] = useMemo(
    () => [
      ...checkPanelAccess(hasAccessToApproveTimeAndLeaves, {
        tabLabel: t(`${translationFields}.absences`),
        tabPanelComponent: <ProjectAssignmentsPendingAbsences />,
        routePath: PENDING_APPROVALS_ROUTES.ABSENCES,
      }),
      ...checkPanelAccess(hasAccessToApproveTimeAndLeaves, {
        tabLabel: t(`${translationFields}.extra_hours`),
        tabPanelComponent: <ProjectAssignmentsPendingExtraHours />,
        routePath: PENDING_APPROVALS_ROUTES.EXTRA_HOURS,
      }),
      ...checkPanelAccess(hasAccessToApproveExpenses, {
        tabLabel: t(`${translationFields}.expence_reports`),
        tabPanelComponent: <ProjectAssignmentsPendingExpenses />,
        routePath: PENDING_APPROVALS_ROUTES.EXPENSE_REPORTS,
      }),
    ],
    [t]
  );

  const selectedTab = useMemo(() => {
    const foundIndex = panels.findIndex((panel) => panel.routePath === query.get("tab"));
    return foundIndex >= 0 ? foundIndex : 0;
  }, [query, panels]);

  return (
    <MultipleTabs
      panels={panels}
      selectedTab={selectedTab}
    />
  );
};

export default ProjectAssignmentsPendingApprovals;
